var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpFormSelect", {
    attrs: {
      name: _vm.name || _vm.path,
      options: _vm.currencies,
      valueField: "code",
      textField: "code",
      readonly: _vm.readonly
    },
    on: {
      input: function($event) {
        return _vm.evh_7315092382398562_input($event, {})
      }
    },
    model: {
      value: _vm.item[_vm.path],
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.path, $$v)
      },
      expression: "item[path]"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }